import { createFileRoute, notFound } from "@tanstack/react-router";
import commissionsStyles from "../styles/commissions.css?url";
import { CommissionList } from "../components/commissions/commission-list";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadCommissions } from "../server/commissions";

/** Commissions (/commissions): the artist's services and whether each is taking requests. */
export const Route = createFileRoute("/commissions/")({
  loader: async () => {
    const data = await loadCommissions();
    if (!data) throw notFound();
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = creatorPageHead(shell, {
      pathname: "/commissions",
      title: `Commissions | ${shell.creator.name}`,
      description: `Commission ${shell.creator.name}: services, prices and how to ask.`,
    });
    return withStylesheet(head, commissionsStyles);
  },
  component: Commissions,
});

function Commissions() {
  return <CommissionList data={Route.useLoaderData()} />;
}
